import { ClientCacheSegmentSettings, GttCancelOrderResponse, GttPlaceOrderResponse, SmartOrderCancelResponse, SmartOrderPlaceResponse } from './../../../../../app.interfaces';
import { Injectable } from '@angular/core';
import {
    MarketSegmentSettingsResponse, PlaceOrderResponse,
    AvilableSettings, DepthScalperOrder, CancelOrderResponse
} from '../../../../../app.interfaces';
import { HttpClient } from '@angular/common/http';
import { of, Subscription } from 'rxjs';
import 'rxjs/add/operator/map';
import { EventsService } from '../../../../../_shared/providers';
import { EVENTS } from '../../../../../_helpers/constants';
import { PlaceOrderRequest, CancelOrderRequest, CancelOrdersRequest, RegulatoryActionRequest, GttPlaceOrderRequest, SuperOrderRequest, SmartOrderRequest } from 'sharedweb/app.interface';
import { ReverseAdvanceOrderType } from 'sharedweb/app.structs';
import { SharedUtils } from 'sharedweb/helpers/shared.utilities';
import { UserTypes } from 'src/app/app.structs';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { WEB_SM_OrderStatusMap } from 'sharedweb/providers/utProto/webSmartOrder_pb';
@Injectable({
    providedIn: 'root'
})
export class OrderService {

    private _clientMarketSegSettings: ClientCacheSegmentSettings = {};
    private _dealerMarketSegSettings: MarketSegmentSettingsResponse = {};
    private _subscriptions: Subscription = new Subscription();
    reCache = false;

    private _avilableSettings: AvilableSettings = {
        avilableOrderType: [],
        avilableProductType: [],
        avilableValidities: [],
        avilableInstruments: [],
        availableMarkets: []
    };

    constructor(
        private _httpClient: HttpClient,
        private _eventService: EventsService,
    ) {


        this._subscriptions.add(
            this._eventService.subscribe(EVENTS.UPDATE_USER_MAPPINGS, (type: string) => {
                this.reCache = true;
            })
        );

    }

    getSegmentSettings(client: string, flag: boolean = false) {
        if (!flag && this._clientMarketSegSettings[client] && !this.reCache) {
            return of(this._clientMarketSegSettings[client]);
        } else if (flag && Object.keys(this._dealerMarketSegSettings).length && !this.reCache) {
            return of(this._dealerMarketSegSettings);
        } else {
            this.reCache = false;
            const url = applicationUrls.segmentSettingsUrl;
            if (flag === false) {
                return this._httpClient
                    .get<MarketSegmentSettingsResponse>(url, {
                        params: <any>{
                            client: client,
                            flag: flag
                        }
                    })
                    .map(data => {
                        this._clientMarketSegSettings[client] = data;
                        this._findAvailableSettings(data);
                        return this._clientMarketSegSettings[client];
                    });
            }
            if (flag === true) {
                return this._httpClient
                    .get<MarketSegmentSettingsResponse>(url, {
                        params: <any>{
                            client: client,
                            flag: flag
                        }
                    }
                    )
                    .map(data => {
                        this._dealerMarketSegSettings = data;
                        this._findGlobalAvailableSettings(data);
                        return this._dealerMarketSegSettings;
                    });
            }
        }
    }


    placeOrder(order: PlaceOrderRequest) {
        const url = applicationUrls.placeOrderUrl;
        return this._httpClient.post<PlaceOrderResponse>(url, order);
    }

    modifyOrder(order: PlaceOrderRequest) {
        const url = applicationUrls.modifyOrderUrl;
        return this._httpClient.put<PlaceOrderResponse>(url, order);
    }

    placeGttOrder(order: GttPlaceOrderRequest) {
        const url = applicationUrls.placeGttOrderUrl;
        return this._httpClient.post<GttPlaceOrderResponse>(url, order);
    }

    placeSmartOrder(order: SmartOrderRequest) {
        const url = applicationUrls.placeSmartOrderUrl;
        return this._httpClient.post<SmartOrderPlaceResponse>(url, order);
    }

    cancelSmartOrder(order_id_string: string) {
        const url = applicationUrls.placeSmartOrderUrl;
        return this._httpClient.delete<SmartOrderCancelResponse>(url +'/' + order_id_string);
    }

    updateSmartOrderStatus(order_id_string: string, status: WEB_SM_OrderStatusMap) {
        const url = applicationUrls.smartOrderStatusUrl + order_id_string;
        return this._httpClient.post(url, {}, { params: { status: status.toString() } });
    }

    placeSuperOrder(order: SuperOrderRequest) {
        const url = applicationUrls.placeSuperOrderUrl;
        return this._httpClient.post<SmartOrderPlaceResponse>(url, order);
    }

    modifySuperOrder(order: SuperOrderRequest) {
        const url = applicationUrls.placeSuperOrderUrl;
        return this._httpClient.put<SmartOrderPlaceResponse>(url, order);
    }

    modifySmartOrder(order: SmartOrderRequest) {
        const url = applicationUrls.placeSmartOrderUrl;
        return this._httpClient.put<SmartOrderPlaceResponse>(url, order);
    }

    cancelSuperOrder(order_id_string: string) {
        const url = applicationUrls.placeSuperOrderUrl;
        return this._httpClient.delete<any>(url +'/' + order_id_string);
    }

    modifyGttOrder(order: GttPlaceOrderRequest) {
        const url = applicationUrls.placeGttOrderUrl;
        return this._httpClient.put<GttPlaceOrderResponse>(url, order);
    }

    cancelGttOrder(order: GttPlaceOrderRequest) {
        const url = applicationUrls.placeGttOrderUrl;
        return this._httpClient.delete<GttCancelOrderResponse>(url, { body: order });
    }

    avilableSettings(): AvilableSettings {
        return this._avilableSettings;
    }

    scalperOrders(filters) {
        const url = applicationUrls.scalperOrder;

        return this._httpClient.get<DepthScalperOrder>(url, {
            params: <any>filters
        });
    }

    cancelOrders(cancelOrderRequest: CancelOrderRequest[]) {
        const url = applicationUrls.scalperOrder;

        return this._httpClient.request<CancelOrderResponse>('delete', url, { body: { data: cancelOrderRequest } });
        // return this._httpClient.delete
    }

    cancelAllOrders(req: CancelOrdersRequest) {
        const url = applicationUrls.cancelAllOrdersUrl;
        return this._httpClient.request<CancelOrderResponse>('delete', url, { body: req });
    }

    isBOProductMapped(market: string, instrument: string, client: string) {
        try {
            let products = [];
            if (SharedUtils.storageHelper.userInfo.userType === UserTypes.client) {
                products = this._clientMarketSegSettings[client][market][instrument].products;
            } else {
                products = this._dealerMarketSegSettings[market][instrument].products;
            }
            return products.includes(ReverseAdvanceOrderType['Bracket Order'])
                || products.includes(ReverseAdvanceOrderType['Cover Order']);
        } catch (e) {
            return false;
        }
    }

    private _findGlobalAvailableSettings(settings: MarketSegmentSettingsResponse) {
        Object.values(settings).forEach(market => {
            Object.keys(market).forEach(instrumentkey => {
                const instrument = market[instrumentkey];

                if (this._avilableSettings.avilableInstruments.indexOf(instrumentkey) === -1) {
                    this._avilableSettings.avilableInstruments.push(instrumentkey);
                }

                instrument.products.forEach(product => {
                    if (this._avilableSettings.avilableProductType.indexOf(product) === -1) {
                        this._avilableSettings.avilableProductType.push(product);
                    }
                });

                Object.values(instrument.order_validity).forEach(productType => {
                    productType.forEach(validity => {

                        if (this._avilableSettings.avilableValidities.indexOf(validity) === -1) {
                            this._avilableSettings.avilableValidities.push(validity);
                        }
                    });
                });

                instrument.order_types.forEach(type => {
                    if (this._avilableSettings.avilableOrderType.indexOf(type) === -1) {
                        this._avilableSettings.avilableOrderType.push(type);
                    }
                });
            });
        });
    }

    private _findAvailableSettings(settings: MarketSegmentSettingsResponse) {
        Object.keys(settings).forEach(marketKey => {
            // Adding unique market to available markets list
            if(this._avilableSettings.availableMarkets.indexOf(marketKey) === -1){
                this._avilableSettings.availableMarkets.push(marketKey);
            }
            const market = settings[marketKey];
            // Iterate through each instrument within the market
            Object.keys(market).forEach(instrumentkey => {
                const instrument = market[instrumentkey];

                if (this._avilableSettings.avilableInstruments.indexOf(instrumentkey) === -1) {
                    this._avilableSettings.avilableInstruments.push(instrumentkey);
                }

                instrument.products.forEach(product => {
                    if (this._avilableSettings.avilableProductType.indexOf(product) === -1) {
                        this._avilableSettings.avilableProductType.push(product);
                    }
                });

                Object.values(instrument.order_validity).forEach(productType => {
                    productType.forEach(validity => {

                        if (this._avilableSettings.avilableValidities.indexOf(validity) === -1) {
                            this._avilableSettings.avilableValidities.push(validity);
                        }
                    });
                });

                instrument.order_types.forEach(type => {
                    if (this._avilableSettings.avilableOrderType.indexOf(type) === -1) {
                        this._avilableSettings.avilableOrderType.push(type);
                    }
                });
            });
        });
    }

    downloadOrders(type: string) {
        const url = applicationUrls.downloadBooksUrl;
        return this._httpClient.get<any>(url, { params: { type } } as any);
    }

    sendRegulatoryAction(request: RegulatoryActionRequest) {
        const url = applicationUrls.sendRegActionUrl;
        return this._httpClient.post<any>(url, request);
    }

}
